/**
 * Asynchronously loads the component for StudentDashboard
 */

import { lazyLoad } from "utils/loadable";

export const StudentDashboard = lazyLoad(
  () => import("./index"),
  (module) => module.StudentDashboard
);
